var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@material-ui/core/Box/Box';
import Button from '@material-ui/core/Button/Button';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import Grid from '@material-ui/core/Grid/Grid';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from 'react';
import { MediaSize } from '../../../nl-lib/common/constants';
import { MappingStorage } from '../../../nl-lib/common/mapper';
import { cloneObj } from '../../../nl-lib/common/util';
import getText from '../../../nl-lib/i18n/language';
import OptionLevel0 from "./OptionDialogComponents/OptionLevel0";
import OptionLevel1 from "./OptionDialogComponents/OptionLevel1";
import OptionLevel2 from "./OptionDialogComponents/OptionLevel2";
import OptionLevelDebug from "./OptionDialogComponents/OptionLevelDebug";
import { convertStringToArray } from './OptionDialogComponents/PageRangeField';
// import { useSelector } from 'react-redux';
// import { RootState } from 'GridaBoard/store/rootReducer';
const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    scrollPaper: {
        alignItems: 'baseline',
        width: "100%"
    },
    buttons: {
        boxShadow: `${"4px 4px 10px rgba(0, 0, 0, 0.3)"} !important`
    }
}));
export const cellRadioStyle = {
    paddingBottom: 2, paddingTop: 2,
    paddingLeft: 0, paddingRight: 0,
    border: "none",
    boxShadow: "none",
};
export const MAX_PRINTOPTION_LEVEL = 1; // 2: debug mode
export const DEFAULT_PRINTOPTION_LEVEL = 0; // 2: debug mode
let _printOption;
export function OptionDialog(props) {
    const { printOption, cancelCallback, okCallback } = props, rest = __rest(props, ["printOption", "cancelCallback", "okCallback"]);
    // const [open, setOpen] = useState(props.open);
    const classes = useStyles();
    // const theme = useTheme();
    const dialogRef = useRef(null);
    const [optionLevel, setOptionLevel] = useState(DEFAULT_PRINTOPTION_LEVEL);
    const isInitialMount = useRef(true);
    /** force to rerender */
    const [value, setValue] = React.useState(0);
    const forceToRender = () => {
        setValue(value + 1);
    };
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            _printOption = cloneObj(printOption);
        }
        else {
            // Your useEffect code here to be run on update
        }
    });
    const setInputFileds = () => {
        const elems = document.getElementsByName("targetPages");
        elems.forEach((elem) => {
            if (elem.value.length > 0) {
                printOption["targetPages"] = convertStringToArray(elem.value);
            }
        });
    };
    const handleClose = (e) => {
        setInputFileds();
        // if (props.cancelCallback) {
        //   props.cancelCallback(printOption);
        // }
        console.log("testing: closing");
    };
    const handleCancel = (e) => {
        console.log("testing: closing");
        setInputFileds();
        // setOpen(false);
        if (props.cancelCallback) {
            props.cancelCallback(printOption);
        }
    };
    const handleOK = (e) => {
        console.log("testing: closing");
        setInputFileds();
        if (props.okCallback) {
            props.okCallback(printOption);
        }
    };
    const onLevelChanged = (level) => {
        setOptionLevel(level);
        console.log(`default: level=${optionLevel}`);
    };
    const handleLevel = (e) => {
        let level = optionLevel + 1;
        level %= MAX_PRINTOPTION_LEVEL + 1;
        setOptionLevel(level);
    };
    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //   const value = (event.target as HTMLInputElement).value;
    //   console.log(value);
    //   setValue(parseInt(value));
    // };
    // const checkAssociatedMappingInfo = () => {
    //   // PrintPdfMain의 printTrigger를 +1 해 주면, 인쇄가 시작된다
    //   const msi = MappingStorage.getInstance();
    //   const pdfToNcodeMapArr = msi.findAssociatedNcode(printOption.fingerprint, printOption.pagesPerSheet);
    //   const pdfToNcodeMap = pdfToNcodeMapArr.length > 0 ? pdfToNcodeMapArr[0] : undefined;
    //   if (!pdfToNcodeMap) {
    //     printOption.forceToUpdateBaseCode = true;
    //     printOption.needToIssuePrintCode = true;
    //   }
    //   else if (pdfToNcodeMap.printPageInfo)
    //     if (printOption.needToIssuePrintCode) {
    //       printOption.pageInfo = { ...g_nullNcode };
    //     }
    //     else {
    //       printOption.pageInfo = { ...pdfToNcodeMap.printPageInfo };
    //     }
    // }
    const handleChange2 = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        const checked = event.target.checked;
        console.log(`event target=${name}, value=${value} checked=${checked}`);
        switch (name) {
            case "hasToPutNcode":
                printOption[name] = checked;
                break;
            case "useNA4":
                printOption["hasToPutNcode"] = !checked;
                break;
            case "targetPages":
                printOption[name] = convertStringToArray(value);
                break;
            case "pagesPerSheet": {
                printOption[name] = parseInt(value);
                const msi = MappingStorage.getInstance();
                const partOption = msi.getCodePrintInfo(printOption, undefined);
                for (const key in partOption)
                    printOption[key] = partOption[key];
                break;
            }
            case "showTooltip":
            case "forceToUpdateBaseCode":
            case "needToIssuePrintCode":
            case "downloadNcodedPdf":
            case "drawCalibrationMark":
            case "drawFrame":
                printOption[name] = checked;
                break;
            case "sameCode": {
                printOption["forceToUpdateBaseCode"] = !checked;
                const msi = MappingStorage.getInstance();
                const partOption = msi.getCodePrintInfo(printOption, undefined);
                for (const key in partOption)
                    printOption[key] = partOption[key];
                break;
            }
            case "newNcode": {
                printOption["forceToUpdateBaseCode"] = checked;
                const msi = MappingStorage.getInstance();
                const partOption = msi.getCodePrintInfo(printOption, undefined);
                for (const key in partOption)
                    printOption[key] = partOption[key];
                break;
            }
            case "mediaSize":
                printOption[name] = MediaSize[value];
                break;
            case "drawMarkRatio":
                printOption[name] = parseInt(value) / 100;
                break;
            case "colorMode":
                printOption[name] = value === "Blue" ? 0 : (value === "Vivid" ? 1 : 2);
                break;
            case "luminanceMaxRatio":
                printOption[name] = parseInt(value) / 100;
                break;
            case "codeDensity":
                printOption[name] = value === getText("print_popup_select_normal") ? 2 : (value === getText("print_popup_detail_ncodelevel_low") ? 1 : 3);
                break;
            case "imagePadding":
                printOption.imagePadding = parseInt(value) + printOption.pdfPagePadding;
                break;
            case "pdfPagePadding":
                printOption.imagePadding = parseInt(value) + printOption.imagePadding - printOption.pdfPagePadding;
                printOption[name] = parseInt(value);
                break;
            case "maxPagesPerSheetToDrawMark":
                printOption[name] = isNaN(parseInt(value)) ? 65536 : parseInt(value);
                break;
            case "debugMode":
                printOption[name] = parseInt(value);
                break;
            default:
                break;
        }
        forceToRender();
    };
    const levelButtonText = [getText("print_popup_toDetail"), "전문가 설정 보기", getText("print_popup_toSimple")];
    console.log(`default: level=${optionLevel}`);
    let msg = levelButtonText[optionLevel];
    if (optionLevel === MAX_PRINTOPTION_LEVEL)
        msg = levelButtonText[levelButtonText.length - 1];
    // const help = printOption ? printOption.showTooltip : true;
    const brZoom = 1; // useSelector((state: RootState) => state.ui.browser.zoom);
    return (_jsx(React.Fragment, { children: _jsxs(Dialog, Object.assign({ open: props.open }, rest, { onClose: handleClose, classes: { scrollPaper: classes.scrollPaper }, style: { overflow: "none", zoom: 1 / brZoom } }, { children: [_jsx(DialogTitle, Object.assign({ id: "form-dialog-title", style: { float: "left" } }, { children: _jsx(Box, Object.assign({ fontSize: 20, fontWeight: "fontWeightBold", style: { float: "left", marginRight: "100px", marginBottom: "-20px" } }, { children: getText("print_popup_title") })) })), _jsxs(DialogContent, Object.assign({ ref: dialogRef }, { children: [_jsxs(DialogContentText, { children: [getText("print_popup_subtitle"), _jsx("br", {}), _jsx("br", {})] }), _jsx(OptionLevel0, Object.assign({}, props, { color: "primary", levelCallback: onLevelChanged, handleChange2: handleChange2, optionLevel: optionLevel })), optionLevel > 0 ? _jsx(OptionLevel1, Object.assign({}, props, { color: "primary", levelCallback: onLevelChanged, handleChange2: handleChange2, optionLevel: optionLevel })) : "", optionLevel > 1 ? _jsx(OptionLevel2, Object.assign({}, props, { color: "primary", levelCallback: onLevelChanged, handleChange2: handleChange2, optionLevel: optionLevel })) : "", optionLevel > 2 ? _jsx(OptionLevelDebug, Object.assign({}, props, { color: "primary", levelCallback: onLevelChanged, handleChange2: handleChange2, optionLevel: optionLevel })) : ""] })), _jsxs(DialogActions, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, sm: 11 }, { children: _jsx(Button, Object.assign({ onClick: handleLevel, color: "primary" }, { children: msg })) })), _jsx(Grid, Object.assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(Button, Object.assign({ className: classes.buttons, onClick: handleOK, variant: "contained", color: "primary", autoFocus: true }, { children: getText("print_popup_yes") })) })), _jsx(Grid, Object.assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(Button, Object.assign({ className: classes.buttons, onClick: handleCancel, variant: "contained" }, { children: getText("print_popup_no") })) }))] })] })) }));
}
export default function OptionDialogButton(props) {
    const { printOption } = props, rest = __rest(props, ["printOption"]);
    const [show, setShow] = useState(false);
    const openDialog = () => {
        //동작함??
        setShow(true);
    };
    const onCancel = () => {
        //동작함??
        setShow(false);
        console.log("onCancel");
    };
    const onOK = () => {
        //동작함??
        setShow(false);
        console.log("onOK");
    };
    return (_jsxs(React.Fragment, { children: [_jsx("button", Object.assign({}, rest, { onClick: openDialog }, { children: props.children })), show ?
                _jsx(OptionDialog, { open: show, cancelCallback: onCancel, okCallback: onOK, printOption: _printOption })
                : ""] }));
}
//# sourceMappingURL=OptionDialog.js.map